import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { UIControlTyp } from 'src/app/core/models/UIControlTyp';
import { AzurePersonRoles } from 'src/app/core/models/AzurePersonRoles';
import { AzurePerson } from 'src/app/core/models/AzurePerson';

@Component({
  standalone: false,
  selector: 'fdb-project-transfer-manager',
  templateUrl: './project-transfer-manager.component.html',
  styleUrls: ['./project-transfer-manager.component.scss']
})
export class ProjectTransferManagerComponent {
  /** Hiermit können Sie bestimmen ob eine DropDown Liste angezeigt wird oder eine MultiSelect Eingabefeld */
  @Input() uiController: UIControlTyp = UIControlTyp.DropDownList;
  @Input() values: string | number | number[];
  roles: AzurePersonRoles = AzurePersonRoles.Any;
  @Output() valuesChange = new EventEmitter();
  @Output() objectChange = new EventEmitter<AzurePerson>();

  onChange(newValue: any) {
    this.values = newValue;
    this.valuesChange.emit(this.values);
  }

  objectChanged(newValue: any) {
    this.objectChange.emit(newValue);
  }

}
